import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROLE_CREATE } from '~/components/routes/administration/roles/permissions'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/administration/roles/new` redirige vers `/administration/access` en ouvrant la modale de
 * création de rôle. La garde `ROLE_CREATE` est conservée : un lien entrant sans ce droit tombe
 * sur la page refusée avant la redirection.
 */
export const Route = createFileRoute('/_authenticated/administration/roles/new')({
  staticData: { permission: ROLE_CREATE },
  beforeLoad: () => {
    throw redirect({
      to: '/administration/access',
      search: { roleForm: 'new' },
    })
  },
})
withRoutePermissions(Route)
